export { default, PanelStateless } from './components/Panel';